<dialog-draggable-header>Source Maintenance</dialog-draggable-header>

<data-table [data]="sources" [columns]="columns" [filterColumnDisplay]="false" [loading]="loading"
   [totalRecords]="total" [lazy]="true" [paging]="true" [pageSize]="this.pageOptions.size" defaultSortField="sourceName"
   (select)="onGridSelectionChange($event)" (edit)="saveHandler($event)" (lazyLoad)="onLazyLoad($event)">
   <ng-container actionStart>
      <button mat-button (click)="onAddSourceClick()" (keydown.enter)="onAddSourceClick()">
         Add Source
      </button>
      <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
      <button mat-button (click)="removeHandler(this.selectedSource)"
         (keydown.enter)="removeHandler(this.selectedSource)">
         Delete Source
      </button>
      <mat-form-field class="spacerLeft">
         <input #searchBar id="search-source-id" type="text" matInput (keydown.enter)="searchBySource(searchBar)"
            [(ngModel)]="searchBarInput" placeholder="Search Source Name" />
         <span *ngIf="searchBarInput" style="margin-left:-20px;">
            <a (click)="clearSearch()">
               <i class="fa fa-times" style="color: rgb(149, 149, 153); cursor: pointer;"></i>
            </a>
         </span>
         <button mat-icon-button matSuffix (click)="searchBySource(searchBar)"
            (keydown.enter)="searchBySource(searchBar)">
            <mat-icon matSuffix>search</mat-icon>
         </button>
      </mat-form-field>
   </ng-container>
   <ng-container actionEnd>
      <button mat-button (click)="close()" (keydown.enter)="close()"> Close </button>
   </ng-container>
</data-table>